import React, { useState } from 'react'
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faMaximize, faMinimize
} from "@fortawesome/free-solid-svg-icons";

import Label from "components/general/Label"
import Target from './target';




function TargetsModalWindow({ data }) {

	const [show, setShow] = useState(false);
	const [contentData, setContentData] = useState({ modalPathImage: null, modalResults: null });
	const handleClose = () => setShow(false);
	const handleShow = (data) => {
		setContentData({ modalData: data })
		setShow(true);
	}
	const index = '1'

	const outButtons =
		<Button key={`buttonsPhotoFinish-${index}`} variant="primary" onClick={() => handleShow(data)} >
			<FontAwesomeIcon className="font-icon" icon={faMaximize} />
		</Button>

	return (
		<>
			{outButtons}
			<Modal dialogClassName='mirs-modal' fullscreen={false} show={show} onHide={handleClose}>
				<Modal.Body>
					<div class="row">
						<div class="col-md-12">
							<div className='d-block mx-auto img-fluid w-100'>

								<Target size={300} shots={contentData.modalData} factor={1} />
								<Target size={300} shots={contentData.modalData} factor={2.5} />

							</div>
						</div>
						<div class="col-md-12 mt-3 p-4">

						</div>
					</div>


				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						<FontAwesomeIcon className="font-icon" icon={faMinimize} />
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);

}

export default TargetsModalWindow;